<template>
  <div>
    <ContactStoreForm :watchRef="this.item.product.manufacturer_sku" :product-id="item.product.id" :product-name="getProductTitle()" @close="() => {$emit('close')}">
      <ProductMiniPreview :item="this.item" :picture="this.picture" />
    </ContactStoreForm>
  </div>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import ProductMiniPreview from './utils/ProductMiniPreview.vue'
import ContactStoreForm from './storeloc/ContactStoreForm.vue'

export default {
  name: 'PdpAppointmentform',
  props: ['item', 'picture'],
  mixins: [ReadyHook],
  components: {
    ContactStoreForm,
    ProductMiniPreview
  },
  methods: {
    getProductTitle() {
      if (this.item.productTitle) {
        return this.item.productTitle
      }

      return this.item.name
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';
</style>
